import styled from "styled-components";

export const InnerContainer = styled.div`
  [type="radio"] {
    display: none;
  }
  max-width: 1174px;
  width: 100%;
  border-bottom: 1px solid rgba(255, 255, 255, 0.24);
  display: flex;
  justify-content: space-around;
`;

export const Container = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
${props => props.titlesLength === 3 ? `
  #r1:checked ~ #slider {
    transform: translate(-102%, 0px);
  }

  #r2:checked ~ #slider {
    transform: translate(0%, 0px);
  }

  #r3:checked ~ #slider {
    transform: translate(102%, 0px);
  }`:

  `#r1:checked ~ #slider {
    transform: translate(-50%, 0px);
  }

  #r2:checked ~ #slider {
    transform: translate(50%, 0px);
  }`
  }
`;

export const Input = styled.input``;

export const Label = styled.label`
  width: 100%;
  max-width: 500px;
  font-weight: bold;
  text-align: center;
  color: #fff;
  height: 70px;
  padding: 20px 0px;

  cursor: pointer;
  font-size: 24px;
  line-height: 36px;

  opacity: ${props => props.checked ? "1" :"0.66"};

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
    font-size: 16px;
  }

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.smallMobile} {
    font-size: 12px;
  }
`;

export const Slider = styled.div`
  max-width: ${props => props.titlesLength === 3 ? '385px' : '585px'}; 
  display: inline-block;
  font-weight: bold;
  text-align: center;
  color: red;
  width: ${props => props.titlesLength === 3 ? '33%' : '50%'};
  height: 70px;
  background-color: transparent;
  position: absolute;
  border-bottom: 3px solid white;
  transition: transform 0.5s;
`;
